if (document.getElementById("jobs")) {
    var request = new XMLHttpRequest();
    request.open("GET", "https://www.clbnetwork.com/data/jobs.json", true);
    request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
            var data = JSON.parse(request.responseText);
            buildJobsList(data);
        } else {
        }
    };

    request.onerror = function () {
        // There was a connection error of some sort
    };

    request.send();

    function buildJobsList(data) {
        if (document.getElementById("jobs")) {
            var jobs_list = document.getElementById("jobs");
            var companyName = jobs_list.dataset.companyName;
            for (var job in data) {
                var job = data[job];

                if (job.company.name == companyName && job.published) {
                    // Make the link list of all active jobs
                    var job_element = document.createElement("a");
                    job_element.setAttribute(
                        "href",
                        `/careers/detail/${job.id}`
                    );
                    job_element.classList.add(
                        "block",
                        "group",
                        "text-base",
                        "text-primary-500",
                        "no-underline",
                        "hover:underline",
                        "flex",
                        "justify-between",
                        "py-4",
                        "mb-2",
                        "border-b",
                        "border-grey-200"
                    );
                    // TODO Instead of reflowing the page for each item, they should be joined and inserted at once.
                    job_element.innerHTML = `<span>${job.title}</span><span>${job.macro_address}</span>`;
                    jobs_list.insertAdjacentElement("beforeend", job_element);

                    // Make the select options in the application form
                    if (document.querySelector("select#position")) {
                        var select_element =
                            document.querySelector("select#position");
                        var option_element = document.createElement("option");
                        option_element.setAttribute("value", job.id);
                        option_element.innerText =
                            job.title + " (" + job.macro_address + ")";
                        select_element.insertAdjacentElement(
                            "beforeend",
                            option_element
                        );
                    }
                }
            }
        }
    }
}
